module.exports = __webpack_public_path__ + "img/inquery-en.f72b51c.png";